import React, { useCallback, useContext, useMemo } from 'react';
import { bool, number, string } from 'prop-types';
import { Link } from 'react-router-dom';
import getSymbolFromCurrency from 'currency-symbol-map';

import AppContext from './context/AppContext';
import ResponsiveImage from './ResponsiveImage';

import '../styles/FeaturedProductItem.css';
import { BsImages } from 'react-icons/bs';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';
import { Button } from 'react-bootstrap';
import { CartContext } from './context/CartContext';

function FeaturedProductItem({ title, price, imageUrl, handle, totalReviews, availableForSale, availableQuantity, inventoryLevelId, bypassNegativeQuantity }) {
    const { appContext } = useContext(AppContext);
    const productPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.PRODUCT_PATH });
    const {
        cartState,
        cartUpdating,
        addLineItem,
        setShowCartOverlay,
    } = useContext(CartContext);
    const appConfig = appContext.config.themeConfig;
    const handleClick = useCallback(async (_e) => {
        await addLineItem(inventoryLevelId, 1);
        setShowCartOverlay(true);
    }, [setShowCartOverlay, addLineItem, inventoryLevelId]);
    const addedQuantity = useMemo(() => {
        if (!cartState) {
            return 0;
        }
        return cartState.filter((i) => i.inventoryLevelId === inventoryLevelId).at(0)?.quantity ?? 0;
    }, [cartState, inventoryLevelId]);
    const quantity = useMemo(() => parseInt((bypassNegativeQuantity ? Infinity : availableQuantity) - addedQuantity),
        [bypassNegativeQuantity, availableQuantity, addedQuantity]);
    return (
        <div
            className={'featured-product-item hover-shadow p-4 text-center'}>
            <Link
                to={`${productPath[0].pathBeforeParams}/${handle}`}>
                {imageUrl ? (
                    <ResponsiveImage
                        imageUrl={imageUrl || appConfig.productNoImageUrl}
                        imageAlt={title || ''}
                        mobileSize={'160px'}
                        desktopSize={'200px'}
                        className={'featured-product-img'}
                    />
                ) : (
                    <BsImages
                        className={'featured-product-item-default-image'} />
                )}
                <p
                    className={'featured-product-item-title'}>{title}</p>
            </Link>
            <p
                className={'fw-bold text-start mb-2'}>
                {getSymbolFromCurrency(appConfig.storeCurrency)}
                {price.toFixed(2)} {appConfig.storeCurrency}
            </p>
            {!totalReviews && (
                <div
                    style={{
                        border: '1px solid gray',
                        padding: '2px 4px',
                        maxWidth: '100px'
                    }}>
                    <span
                        style={{
                            color: 'gray',
                            fontSize: '12px',
                        }}>NOT RATED</span>
                </div>
            )}
            <div
                className={'d-flex justify-content-center mt-2'}>
                <Button
                    onClick={handleClick}
                    disabled={(cartUpdating || !availableForSale || quantity <= 0)}
                    style={{
                        width: '100%',
                        border: 'none',
                    }}
                    className={'btn-sm add-to-cart-btn px-4 py-2'}>
                    Add to Cart
                </Button>
            </div>
        </div>
    );
}

FeaturedProductItem.propTypes = {
    title: string,
    price: number,
    imageUrl: string,
    handle: string,
    totalReviews: number,
    availableForSale: bool,
    availableQuantity: number,
    inventoryLevelId: number,
    bypassNegativeQuantity: bool,
};

export default FeaturedProductItem;